import Image, { StaticImageData } from "next/legacy/image";

const ImageWithCaption: React.FC<{
  src: StaticImageData;
  caption: string;
  altText: string;
}> = ({ src, caption, altText }) => {
  return (
    <div className="relative w-[230px] mt-4 rounded-md">
      <Image layout="responsive" src={src} alt={altText} />
      <p className="caption text-coinage-body mt-2">{caption}</p>
    </div>
  );
};

export default ImageWithCaption;
